import React from 'react';

export class SupportNumberScreenreader extends React.Component {
    render() {
        const {screenReaderSupportText, screenReaderSupportNumber} = this.props;
        let accessibilityText = screenReaderSupportText + screenReaderSupportNumber;
        return (
            <a className="sr-only" href={`tel:${ screenReaderSupportNumber}`}>
                {accessibilityText}
            </a>
        );
    }
}
